// src/components/WelcomePage.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './WelcomePage.css';
import logoImg from '../assets/M2_Lab_Logo.png';
import marketingImg from '../assets/Marketing.png';

export default function WelcomePage() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (countdown === 0) {
      navigate('/');
    }
  }, [countdown, navigate]);

  return (
    <div className="welcome-page">
      <header className="login-navbar">
        <div className="login-logo-container" onClick={() => navigate('/')}>
          <img src={logoImg} alt="M2 Lab Logo" className="login-logo-img" />
          <span className="login-lab-title">Purdue M2 Lab</span>
        </div>
      </header>

      <div className="welcome-content">
        <div className="welcome-text">
          <h1>Welcome to SynthGuard!</h1>
          <p>Your account has been successfully created. You can now explore our cutting-edge deepfake detection tools and contribute to the future of AI research at Purdue.</p>
          
          <p className="countdown-text">
            You will be redirected to Home page in {countdown} second{countdown !== 1 && 's'}...
          </p>

          <button className="explore-button" onClick={() => navigate('/upload')}>Get Started</button>
        </div>

        <div className="welcome-image">
          <img src={marketingImg} alt="Marketing" />
        </div>
      </div>

      <footer className="login-footer">© 2025 Purdue University</footer>
    </div>
  );
}
